import { render } from "./GibergLWatches.vue?vue&type=template&id=3c29370b&scoped=true"
import script from "./GibergLWatches.vue?vue&type=script&lang=js"
export * from "./GibergLWatches.vue?vue&type=script&lang=js"

import "./GibergLWatches.vue?vue&type=style&index=0&id=3c29370b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c29370b"]])

export default __exports__